<template>
  <div id="contenedor-desktop-listado-contrato-actividades">
    <v-row>
      <!-- Actividades de diario -->
      <v-col
        cols="12"
        md="4">
        <v-card
          flat>
          <v-toolbar
            flat>
            <v-toolbar-title>
              Diario
              <v-chip
                small
                :disabled="getActividadesDiario.length <= 0">
                {{ getActividadesDiario.length }}
              </v-chip>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="registrarActividad(1)">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-toolbar>
          <!-- Mostrar las actividades de diario [tipo=1] -->
          <v-list
            class="px-1 bkground">
            <v-list-item
              v-if="$apollo.loading">
              <v-skeleton-loader
                v-bind="attrs"
                width="100%"
                type="article, actions">
              </v-skeleton-loader>
            </v-list-item>
            <template
              v-for="actividad in getActividadesDiario">
              <template>
                <v-list-item
                  :key="`actividad-${actividad.id}`">
                  <!-- Actividad card -->
                  <actividad-card
                    :actividad=actividad>
                  </actividad-card>
                </v-list-item>
              </template>
            </template>
            <v-alert
              v-if="getActividadesDiario.length <= 0"
              type="info">
              No existen actividades registradas para este tipo.
            </v-alert>
          </v-list>
        </v-card>
      </v-col>
      <v-divider
        vertical>
      </v-divider>
      <v-col
        cols="12"
        md="4">
        <v-card
          flat>
          <v-toolbar
            flat>
            <v-toolbar-title>
              Informes
              <v-chip
                small
                color="info"
                :disabled="getActividadesInformes.length <= 0">
                {{ getActividadesInformes.length }}
              </v-chip>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="registrarActividad(2)">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-toolbar>
          <!-- Mostrar las actividades de diario [tipo=2] -->
          <v-list
            class="px-3 bkground">
            <v-list-item
              v-if="$apollo.loading">
              <v-skeleton-loader
                v-bind="attrs"
                width="100%"
                type="article, actions">
              </v-skeleton-loader>
            </v-list-item>
            <template
              v-for="actividad in getActividadesInformes">
              <template>
                <v-list-item
                  :key="`actividad-${actividad.id}`">
                  <!-- Actividad card -->
                  <actividad-card
                    :actividad=actividad>
                  </actividad-card>
                </v-list-item>
              </template>
            </template>
            <v-alert
              v-if="getActividadesInformes.length <= 0"
              type="info">
              No existen actividades registradas para este tipo.
            </v-alert>
          </v-list>
        </v-card>
      </v-col>
      <v-divider
        vertical>
      </v-divider>
      <v-col
        cols="12"
        md="4">
        <v-card
          flat>
          <v-toolbar
            flat>
            <v-toolbar-title>
              Album
              <v-chip
                small
                :disabled="getActividadesAlbum.length <= 0">
                {{ getActividadesAlbum.length }}
              </v-chip>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn
              icon
              @click="registrarActividad(3)">
              <v-icon>
                mdi-plus
              </v-icon>
            </v-btn>
          </v-toolbar>
          <!-- Mostrar las actividades de diario [tipo=3] -->
          <v-list
            class="px-3 bkground">
            <v-list-item
              v-if="$apollo.loading">
              <v-skeleton-loader
                v-bind="attrs"
                width="100%"
                type="article, actions">
              </v-skeleton-loader>
            </v-list-item>
            <template
              v-for="actividad in getActividadesAlbum">
              <template>
                <v-list-item
                  :key="`actividad-${actividad.id}`">
                  <!-- Actividad card -->
                  <actividad-card
                    :actividad=actividad>
                  </actividad-card>
                </v-list-item>
              </template>
            </template>
            <v-alert
              v-if="getActividadesAlbum.length <= 0"
              type="info">
              No existen actividades registradas para este tipo.
            </v-alert>
          </v-list>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import eventBus from '@/helpers/eventBus';
import ActividadCard from './Card.vue';

export default {
  name: 'DesktopListadoContratoActividades',
  components: {
    ActividadCard,
  },
  props: {
    listado: Array,
  },
  data() {
    return {
    };
  },
  methods: {
    registrarActividad(tipo) {
      eventBus.$emit('registrar-actividad-contrato', tipo);
    },
  },
  computed: {
    getActividadesDiario() {
      return this.listado.filter(({ tipo }) => tipo === 1)
        .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));
    },
    getActividadesInformes() {
      return this.listado.filter(({ tipo }) => tipo === 2)
        .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));
    },
    getActividadesAlbum() {
      return this.listado.filter(({ tipo }) => tipo === 3)
        .sort((a, b) => new Date(`${b.fecha} 00:00:0`) - new Date(`${a.fecha} 00:00:0`));
    },
  },
};
</script>

<style lang="scss">

</style>
